import { FC, useState } from 'react';
import { calculatPrice } from '../../core/price';
import { useDimensions } from '../Viewer';

const minDimensions = [6, 9];
const maxDimensions = [36, 54];
const priceRange = [15, 39];

interface iSliderProps {
  numberOfLines: number;
  lineWidth: number;
  letterNumber: number;
  defaultValue: number;
  content: any;
  config: any;
  lineHeight: number;
  onSubmit: (width: number, height: number, price: number) => void;
}
const Slider: FC<iSliderProps> = ({ onSubmit, letterNumber, defaultValue, content, lineHeight, config }) => {
  const [value, setValue] = useState((defaultValue - minDimensions[0]) / (maxDimensions[0] - minDimensions[0]));
  const _val = Math.round((((maxDimensions[0] - minDimensions[0]) * value + minDimensions[0]) * 100) / 100);
  const _height = Math.round((((maxDimensions[1] - minDimensions[1]) * value + minDimensions[1]) * 100) / 100);

  const _handleChange = ({ target: { value } }: any) => setValue(value);

  const price = (priceRange[1] - priceRange[0]) * value + priceRange[0];
  const _size = `CUSTOM_${Math.round(_val)}`;
  const _price = calculatPrice(_size, content, config);

  // console.log(_height, price);

  const dims = useDimensions(_size, content, lineHeight);
  const _handleSubmit = () => onSubmit(Math.round(_val), Math.round(_height), Math.round(price * 100) / 100);
  return (
    <div className='slider-wrapper'>
      <div className='container'>
        <h2>Custom</h2>
        <p>
          {Math.round(dims.width)}cm
          <span>£{Math.round(_price * 100) / 100}</span>
        </p>
        <input type='range' value={value} onChange={_handleChange} max={1} step={0.000001} />
        <div className='row'>
          <button onClick={_handleSubmit}>OK</button>
        </div>
      </div>
    </div>
  );
};

export default Slider;
